import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useMessage } from '@/const/messages';
import { useAuthenticate } from '@/logics/auth';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { format, MENUS_MESSAGES } = useMessage();
        const { onLogout } = useAuthenticate();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "logout",
                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(onLogout)(true)))
            }, [
                _createVNode(MaterialIcon, {
                    name: "logout middle",
                    class: "icon"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(MENUS_MESSAGES).LOGOUT)), 1)
            ]));
        };
    }
});
